export function formatCurrency(value: number): string {
  const formatted = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value);

  return formatted;
}
export const convertMinsToHrsMins = (mins: number): string => {
  const isNegative = mins < 0;
  const positiveMins = isNegative ? mins * -1 : mins;

  const h = Math.floor(positiveMins / 60);
  const m = Math.floor(positiveMins % 60);

  const hStr = `${isNegative ? '-' : ''}${h < 10 ? `0${h}` : h}`;
  const mStr = m < 10 ? `0${m}` : m;
  return `${hStr}:${mStr}`;
};
